{
  "accountInformation": "Hesap Bilgileri",
  "accountStatus": "Hesap Durumu",
  "active": "Aktif",
  "admin": "Yönetici",
  "adminBadge": "Yönetici",
  "adminPrivileges": "Yönetici Yetkileri",
  "aiDefaultHelp": "Bugün size nasıl yardımcı olabilirim?",
  "aiDepositHelp": "Para yatırma sorunları, gecikmeler veya onaylar hakkında sorun.",
  "aiKycHelp": "KYC doğrulama ve belge gereksinimleri hakkında sorun.",
  "aiLoginHelp": "Giriş, şifre veya hesap erişim sorunları hakkında sorun.",
  "aiP2pHelp": "P2P emirleri, itirazlar veya ödeme sorunları hakkında sorun.",
  "aiSupportAssistant": "AI Destek Asistanı",
  "aiSupportAssistantText": "Sık sorulan sorulara anında yanıt alın veya ekibimiz için bir talep oluşturun.",
  "aiWithdrawHelp": "Para çekme durumu, gecikmeler veya gereksinimler hakkında sorun.",
  "askAiSupport": "AI Desteğine Sor",
  "bio": "Profesyonel Biyografi",
  "capital": "Sermaye",
  "changeImage": "Resmi Değiştir",
  "cnicBack": "Kimlik Kartı (Arka)",
  "cnicFront": "Kimlik Kartı (Ön)",
  "connectedWallet": "Bağlı Cüzdan",
  "country": "Ülke",
  "createSupportTicket": "Destek Talebi Oluştur",
  "describeIssue": "Sorununuzu açıklayın",
  "disabled": "Devre Dışı",
  "displayName": "Görünen Ad",
  "editProfile": "Profili Düzenle",
  "email": "E-posta",
  "emailOtpSendFailed": "Doğrulama kodu gönderilemedi. Lütfen tekrar deneyin.",
  "emailOtpSent": "Doğrulama kodu e-postanıza gönderildi.",
  "emailVerification": "E-posta Doğrulama",
  "emailVerifiedSuccessfully": "E-posta başarıyla doğrulandı.",
  "enabled": "Etkin",
  "enterEmailOtp": "Doğrulama kodunu girin",
  "enterOtpFirst": "Lütfen önce doğrulama kodunu girin.",
  "estimatedProfit": "Tahmini Kâr",
  "faceVerificationNotAutomated": "Otomatik yüz doğrulama henüz mevcut değil. Yüklediğiniz selfie, KYC onayının bir parçası olarak manuel olarak incelenecektir.",
  "failedLoadNotifications": "Bildirimler yüklenemedi.",
  "failedMarkAllRead": "Tümü okundu olarak işaretlenemedi.",
  "failedMarkRead": "Okundu olarak işaretlenemedi.",
  "failedSubmitTicket": "Talep gönderilemedi.",
  "fullLegalName": "Tam Yasal Ad",
  "fullName": "Ad Soyad",
  "idNumber": "Kimlik Numarası",
  "imagePreview": "Resim Önizleme",
  "imageTooLarge": "Maksimum resim boyutu 5 MB'dır.",
  "inactive": "Pasif",
  "invalidImageType": "Yalnızca JPG, PNG ve WEBP resimlerine izin verilir.",
  "invalidOtp": "Geçersiz veya süresi dolmuş kod. Lütfen tekrar deneyin.",
  "joinedDate": "Katılma Tarihi",
  "kycStatus": "KYC Durumu",
  "kycSubmissionFailed": "KYC gönderimi başarısız oldu.",
  "kycSubmittedSuccessfully": "KYC başarıyla gönderildi.",
  "lastLogin": "Son Giriş",
  "liquidationZone": "Likidasyon Bölgesi",
  "loadingNotifications": "Bildirimler yükleniyor...",
  "loadingProfile": "Profil yükleniyor...",
  "markAllRead": "Tümünü Okundu Olarak İşaretle",
  "mobileNumberCountryCode": "Cep Telefonu Numarası (Ülke Kodu ile)",
  "network": "Ağ",
  "noNotifications": "Henüz bildirim yok.",
  "noUtilityToolsFound": "Yardımcı araç bulunamadı.",
  "notSubmitted": "Gönderilmedi",
  "notVerifiedEmail": "Doğrulanmadı",
  "openTool": "Aracı Aç",
  "owner": "Sahip",
  "ownerBadge": "Sahip",
  "ownerControlCenter": "Sahip Kontrol Merkezi",
  "passportNationalId": "Pasaport / Kimlik Kartı",
  "pending": "Beklemede",
  "phoneNumber": "Telefon Numarası",
  "positionSize": "Pozisyon Büyüklüğü",
  "positionValue": "Pozisyon Değeri",
  "processing": "İşleniyor...",
  "profileImage": "Profil Resmi",
  "profileSecurity": "Profil Güvenliği",
  "profileSubtitle": "Hesap profilinizi, güvenliğinizi, kimliğinizi ve kişisel bilgilerinizi yönetin.",
  "profileTitle": "Profil",
  "profileUpdateFailed": "Profil güncelleme başarısız oldu.",
  "profileUpdatedSuccessfully": "Profil başarıyla güncellendi.",
  "read": "Okundu",
  "rejected": "Reddedildi",
  "removeImage": "Resmi Kaldır",
  "required": "Gerekli",
  "riskAmount": "Risk Tutarı",
  "riskPercent": "Risk Yüzdesi",
  "riskPositionCalculator": "Risk ve Pozisyon Hesaplayıcı",
  "role": "Rol",
  "saveProfile": "Profili Kaydet",
  "savingProfile": "Profil Kaydediliyor...",
  "securityLevel": "Güvenlik Seviyesi",
  "selfieVerification": "Selfie Doğrulama",
  "sendEmailOtp": "E-posta OTP Gönder",
  "sendingEmailOtp": "Gönderiliyor...",
  "serverError": "Sunucu hatası.",
  "sessionActive": "Oturum Aktif",
  "sessionExpired": "Oturum süresi doldu. Lütfen tekrar giriş yapın.",
  "subject": "Konu",
  "submitKyc": "KYC Gönder",
  "submitTicket": "Talebi Gönder",
  "submittingKyc": "KYC Gönderiliyor...",
  "supportBadge": "Destek",
  "supportRequiredFields": "Konu ve açıklama zorunludur.",
  "telegram": "Telegram Kullanıcı Adı",
  "ticketSubmittedSuccessfully": "Talep başarıyla gönderildi.",
  "tools": "Araçlar",
  "totalNotifications": "Toplam Bildirim",
  "twoFactorStatus": "İki Faktörlü Kimlik Doğrulama",
  "uid": "UID",
  "unread": "Okunmadı",
  "updateSuccessful": "Profil başarıyla güncellendi.",
  "uploadBackSide": "Arka Yüzü Yükle",
  "uploadDocument": "Belge Yükle",
  "uploadFrontSide": "Ön Yüzü Yükle",
  "uploadIdDocument": "Lütfen bir kimlik belgesi yükleyin.",
  "uploadImage": "Resim Yükle",
  "uploadSelfie": "Selfie Yükle",
  "uploadSelfieRequired": "Göndermeden önce lütfen bir selfie yükleyin.",
  "user": "Kullanıcı",
  "userId": "Kullanıcı ID",
  "userProfile": "Kullanıcı Profili",
  "utilityTools": "Yardımcı Araçlar",
  "verified": "Doğrulandı",
  "verifiedBadge": "Doğrulandı",
  "verifiedEmail": "Doğrulandı",
  "verifyEmailFirst": "Lütfen önce e-postanızı doğrulayın.",
  "verifyingEmailOtp": "Doğrulanıyor...",
  "walletAddress": "Cüzdan Adresi",
  "walletOrderTxOptional": "Cüzdan adresi, emir ID'si veya işlem ID'si (isteğe bağlı)",
  "writeProfessionalBio": "Kendiniz hakkında profesyonel bir tanıtım yazın."
}